// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"622ff532","133":"5cdc77cb","544":"e8d48c02","557":"bd1d67e8","568":"e6d92ae5"}[chunkId] + ".chunk.js";
};